import React from "react";
import Button from "../Button/Button";
import "./1vs1.css";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { GamePopupContext } from "../Context/GamePopupContext";
import { CodeContext } from "../Context/CodeContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { verifyRoom } from "../../GameServices/GameServices";
import { useAuthContext } from "../../AuthContext";
import { GetGameDetails } from "../../GameServices/GameServices";

function JoinRoom({ gameImage }) {
  const { dispatchPopUp, gameState } = useContext(GamePopupContext);
  const { dispatch, state } = useContext(CodeContext);
  const [Amount, setAmount] = useState(null);
  const [showModal, setshowModal] = useState(false);
  const { walletBalance } = useAuthContext();
  const navigate = useNavigate();
  const handleRoomJoin = async () => {
    let response = await verifyRoom(Amount);
    if (response.statusCode && response.statusCode === "10000") {
      console.log("join bet", response?.data?.challenge);
      let { data } = await GetGameDetails(response?.data?.challenge?.gameName);
      console.log(data);
      dispatch({ type: "CODE", data: Amount });
      navigate(`/match`, {
        state: {
          id: 0,
          gameBuild: data?.gameBuild,
          gameClass: data?.gameClass,
          isCustomBet: true,
          direct: true,
          name: response?.data?.challenge?.gameName,
        },
      });
      dispatchPopUp({ type: "close" });
    } else {
      console.log("here", response.response.data.message);
      setshowModal(true);
      dispatchPopUp({ type: "close" });
      alert(response.response.data.message);

      return;
    }
  };

  return (
    <>
      <Modal
        show={gameState.showJoin}
        onHide={() => dispatchPopUp({ type: "close" })}
        className="gamescreen-modal"
      >
        <div className="section-onevsone join-a-room-after">
          <div className="container">
            <div className="row matic-row">
              <div className="col-lg-6">
                <div className="matic-info">
                  <div className="matic-image">
                    <img src={require("./images/matic.png")} alt="matic" />
                  </div>
                  <div className="matic-text">
                    <h3>{(walletBalance?.balance / 10 ** 18).toFixed(5)}</h3>
                    <p>Matic Available</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 cancel-image">
                <img
                  src={require("./images/cancel-error-popup.png")}
                  onClick={() => dispatchPopUp({ type: "close" })}
                  alt="popup"
                />
              </div>
            </div>
            <div className="row head-row">
              <div className="col-lg-12">
                <h1>Enter Code</h1>
              </div>
              <div className="col-lg-8">
                <div className="form-us form-input-settings">
                  <input
                    onChange={(e) => setAmount(e.target.value)}
                    type="text"
                    className="form-control matic-amount"
                    placeholder="Enter your code"
                  />
                  <div className="col-lg-2">
                    <img src={require("./images/matic.png")} alt="matic" />
                  </div>
                </div>
                <div className="col-lg-12">
                  <Button
                    value="Join Room"
                    onClick={() => {
                      handleRoomJoin();
                    }}
                    disabled={Amount !== null && Amount !== "" ? false : true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
export default React.memo(JoinRoom);
